// extracted by mini-css-extract-plugin
export default {"image":"image-upload-box_image__u2iHg"};